import React, { useEffect, useRef, useState } from 'react';

type Props = {
  description: {
    description: string;
  };
};

const EmbedForm = ({ description }: Props) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [iframeHeight, setIframeHeight] = useState('2400px');
  const iFrameIntervalRef = useRef<ReturnType<typeof window.setInterval>>();
  const isFirstLoad = useRef(true);

  const resizeIframe = () => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const height = iframe.contentWindow?.document.body.scrollHeight;
    if (height) {
      setIframeHeight(`${height + 20}px`);
      clearInterval(iFrameIntervalRef?.current);
    }
  };

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    iFrameIntervalRef.current = setInterval(() => {
      resizeIframe();
    }, 500);

    iframe.onload = () => {
      // Store the initial position of the iframe
      const iframeTop = iframe.getBoundingClientRect().top + window.scrollY;

      resizeIframe();

      // Set up MutationObserver to watch for content changes
      const observer = new MutationObserver(() => {
        setTimeout(() => {
          resizeIframe();
          // Scroll only if it's not the first load
          if (!isFirstLoad.current) {
            window.scrollTo(0, iframeTop - 50);
          }
          isFirstLoad.current = false;
        }, 500);
      });

      if (iframe.contentWindow?.document.body) {
        observer.observe(iframe.contentWindow.document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          characterData: true,
        });
      }
    };

    window.addEventListener('resize', resizeIframe);

    return () => {
      window.removeEventListener('resize', resizeIframe);
    };
  }, []);

  return (
    <iframe
      ref={iframeRef}
      srcDoc={description.description}
      sx={{ width: '100%', height: iframeHeight, border: 'none', overflow: 'hidden' }}
      title="Affiliate Form"
    />
  );
};

export default EmbedForm;
